export const EngagementDashboardsRoutes = {
    "/compaas-dashboard": {
        "name": "appLayout.harriSH.dashboards-compaas",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("./dashboards.module.js");
                }
            }
        ]
    },
    "/tl-compaas-dashboard": {
        "name": "appLayout.schedule.tl-compaas-dashboard",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("./dashboards.module.js");
                }
            },
        ],
    },
    "/dashboard/gp-main-dashboard": {
        "name": "appLayout.harriSH.dashboards-main-gp",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("./dashboards.module.js");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("../../hmodules/save-views/save-views.module.js");
                }
            },
        ],
    },
    "/dashboard/parent-main-dashboard?date": {
        "name": "appLayout.harriSH.dashboards-main-parent",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("./dashboards.module.js");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("../../hmodules/save-views/save-views.module.js");
                }
            },
        ],
    },
};
